import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: 'app-checkbox',
  standalone: true,
  imports: [],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    }
  ]
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() label: string = null;
  @Input() disabled: boolean = false;
  @Input() labelBefore: boolean = false;
  @Input() underline: boolean = false;
  @Input() note: string = null;
  @Input() boldLabel: boolean = false;
  @Input() textSize: 'sm' | 'md' | 'lg' = 'md';

  value: boolean = false;
  private onChange: (value: boolean) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: boolean): void {
    this.value = value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  toggleValue(newValue: boolean): void {
    if (this.disabled) {
      return;
    }

    if (this.value !== newValue) {
      this.value = newValue;
      this.onChange(this.value);
      this.onTouched();
    }
  }

  onCheckboxChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.toggleValue(checked);
  }

  onToggle() {
    this.toggleValue(!this.value);
  }
}
